import React, { useState, useEffect } from 'react'
import { FaAngleLeft, FaAngleRight, FaRegWindowMinimize } from 'react-icons/fa'
import { MdStar } from 'react-icons/md'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import { durationFormat } from 'variables/functions'
import { LINK_BASE, PUBLIC_LINK_BASE } from 'variables/general'
import { packageCategories } from 'variables/general'

const MarketplaceCard = (props) => {
  const [showIndicators, setShowIndicators] = useState(window.innerWidth > 700 ? false : true)

  let newTabURL
  let packageURL
  if (props.page === 'marketplace' || window.location.href.includes('marketplace')) {
    // newTabURL is for a full open in new tab navigation
    newTabURL =
      props.package.category > 1
        ? `${LINK_BASE}/marketplace-portfolio/${props.package.photographer.identifier}`
        : ''

    packageURL = `${LINK_BASE}/marketplace-package/${props.package.identifier}`
  } else if (!!props.recommended) {
    // newTabURL is for a full open in new tab navigation
    newTabURL =
      props.package.category > 1
        ? `${PUBLIC_LINK_BASE(props.package.photographer)}/portfolio/${props.package.photographer.identifier}`
        : ''

    packageURL = `${PUBLIC_LINK_BASE(props.package.photographer)}/package/${props.package.identifier}`
  } else {
    // newTabURL is for a full open in new tab navigation
    newTabURL =
      props.package.category > 1
        ? `${LINK_BASE}/marketplace-portfolio/${props.package.photographer.identifier}`
        : ''

    packageURL = `${LINK_BASE}/marketplace-package/${props.package.identifier}`
  }

  // ONLY LOAD ONE IMAGE IF THE MARKETPLACE CARD IS ON MARKETPLACE-PACKAGE OR MARKETPLACE-PORTFOLIO
  let images = props.items
  let itemRow1 = []
  if (props.page !== 'marketplace') {
    const array = []
    array.push(props.items[0])
    images = array
  }

  // IMAGE ARRAY TO ALLOW FOR DEFAULT FORWARD AND BACKWARDS CAROUSEL TRAVERSING
  if (images) {
    itemRow1 = images.map((item, index) => (
      <ImageContainer key={uuidv4()} page={props.page}>
        <Image
          page={props.page}
          src={item && (item.mobileThumbnail || item.thumbnail)}
          alt={`${props.package.title} Photo by ${props.package.photographer.companyName} in ${
            packageCategories[props.package.category].name
          } Package, ${props.package.location.name}`}
          index={index}
        />
      </ImageContainer>
    ))
  }

  const [itemIndex, setitemIndex] = useState(0)
  const [itemArray, setItemArray] = useState(itemRow1)
  // const [transitionEnabled, setTransitionEnabled] = useState(false)
  useEffect(() => {
    setItemArray(itemRow1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.items])
  // LOGIC FOR SHOWING WHAT TRAVERSE INDICATOR SHOULD HAVE ITS OPACITY SET TO ONE
  const TraverseIndicators = props.items.map((item, index) => {
    let shown = 'false'
    if (itemIndex + 1 > itemRow1.length && itemIndex - itemRow1.length === index) {
      shown = 'true'
    } else if (itemIndex < itemRow1.length && itemIndex === index) {
      shown = 'true'
    }

    return <TraverseIndicator key={item.identifier} shown={shown} />
  })

  // SET TIMEOUTS TO ONLY ENABLE THE CSS TRANSITION FEATURE FOR ONCLICK HANDLER USE
  const previousHandler = async () => {
    setTimeout(() => {
      if (itemIndex === 0) {
        setitemIndex(itemArray.length - 1)
      } else {
        setitemIndex(itemIndex - 1)
      }
    }, 5)
  }

  // PREVIOUS INDEX AND NEXTINDEX USED TO PRERENDER IMAGES
  const previousIndex = () => {
    if (itemIndex === 0) {
      return itemArray.length - 1
    } else {
      return itemIndex - 1
    }
  }

  const nextHandler = async () => {
    setTimeout(() => {
      if (itemIndex === itemArray.length - 1) {
        setitemIndex(0)
      } else {
        setitemIndex(itemIndex + 1)
      }
    }, 5)
  }

  const nextIndex = () => {
    if (itemIndex === itemArray.length - 1) {
      return 0
    } else {
      return itemIndex + 1
    }
  }

  let leftOffset = `${itemIndex * -45}em`

  // TO HANDLE CASES OF ONLY ONE, TWO, OR THREE+ IMAGES IN CAROUSEL TO AVOID SAME KEY ERRORS
  const photoArray = !props.loadAll
    ? itemArray[itemIndex]
    : itemArray.length === 1
    ? itemArray[itemIndex]
    : itemArray.length === 2
    ? [itemArray[previousIndex()], itemArray[itemIndex], <ImageContainer key={uuidv4()}></ImageContainer>]
    : [itemArray[previousIndex()], itemArray[itemIndex], itemArray[nextIndex()]]

  let currencySymbol =
    props?.package?.photographer?.overrideCurrencySymbol ?? props.package.photographer.currencySymbol ?? '$'

  let currencyCode =
    props?.package?.photographer?.overrideCurrencyCode ?? props.package.photographer.currencyCode

  return (
    <Container
      page={props.page}
      onMouseEnter={() => {
        if (window.innerWidth > 700) {
          setShowIndicators(true)
        }
      }}
      onMouseLeave={() => {
        if (window.innerWidth > 700) {
          setShowIndicators(false)
        }
      }}
    >
      <ViewPort page={props.page}>
        {itemArray.length > 1 && showIndicators && <LeftIndicator onClick={previousHandler} />}
        {itemArray.length > 1 && showIndicators && <RightIndicator onClick={nextHandler} />}
        <FlexRow>{itemArray.length > 1 && showIndicators && TraverseIndicators}</FlexRow>
        <ImageRowContainer href={packageURL} leftOffset={leftOffset} rel="noopener" target="_blank">
          <PreRenderImageRow>{photoArray}</PreRenderImageRow>
        </ImageRowContainer>
        {itemArray.length > 1 && showIndicators && (
          <LeftTraversal
            onClick={() => {
              previousHandler()
            }}
          ></LeftTraversal>
        )}
        {itemArray.length > 1 && showIndicators && (
          <RightTraversal
            onClick={() => {
              nextHandler()
            }}
          ></RightTraversal>
        )}
        <Middle href={packageURL} rel="noopener" target="_blank"></Middle>
      </ViewPort>
      <Column page={props.page}>
        <SubWrapper1>
          {props.package.title && (
            <H1 href={packageURL} rel="noopener" target="_blank" style={{ margin: '0 0 5px 0' }}>
              {props.package.title}
            </H1>
          )}
          {props.page === 'marketplace' && (
            <H2 href={packageURL} rel="noopener" target="_blank">{`${durationFormat(
              props.package.hoursOfCoverage,
            )}`}</H2>
          )}
          <H5 href={packageURL} rel="noopener" target="_blank">
            {props.package.startingAt ? 'Starting at ' : ''}
            {currencySymbol}
            {`${~~props.package.price}
                  ${currencyCode && currencyCode.toUpperCase()}`}
          </H5>
        </SubWrapper1>
        <Row3>
          <SubWrapper>
            <ImgWrap href={newTabURL} rel="noopener" target="_blank">
              <AvatarImg
                src={props.package.photographer.displayImage}
                alt="marketplace photographercard avatar image"
              />
            </ImgWrap>
            <Column1>
              <H6 href={newTabURL} rel="noopener" target="_blank">
                {props.package.photographer.companyName}
              </H6>
              <Row2 href={newTabURL} rel="noopener" target="_blank">
                <LocationTitle>
                  {props.package.photographer.location
                    ? props.package.photographer.location.name.substr(
                        0,
                        props.package.photographer.location.name.lastIndexOf(','),
                      )
                    : 'Victoria, BC'}
                </LocationTitle>
              </Row2>
              {props.package.photographer.review && (
                <Row2 href={props.package.photographer?.review?.url} rel="noopener" target="_blank">
                  <React.Fragment>
                    <StarIcon />
                    <Reviews>
                      {props.package.photographer?.review?.rating} (
                      {props.package.photographer?.review?.number} Reviews)
                    </Reviews>
                  </React.Fragment>
                </Row2>
              )}
              {window.innerWidth <= 1370 && window.innerWidth > 700 && !!props.recommended && (
                <Link1 href={packageURL} rel="noopener" target="_blank">
                  Booking Info
                </Link1>
              )}
            </Column1>
          </SubWrapper>
        </Row3>
      </Column>
      {!!props.recommended ? (
        (window.innerWidth > 1370 || window.innerWidth <= 700) && (
          <Link href={packageURL} rel="noopener" target="_blank">
            Booking Info
          </Link>
        )
      ) : (
        <Link href={packageURL} rel="noopener" target="_blank">
          Booking Info
        </Link>
      )}
    </Container>
  )
}

export default MarketplaceCard

const Container = styled.div`
  position: relative;
  display: flex;
  height: ${(props) => (props.page === 'marketplace' ? '32em' : '26em')};
  width: 100%;
  align-items: center;
  @media (max-width: 1400px) {
    height: 25em;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    width: 90vw;
    height: ${(props) => (props.page === 'marketplace' ? 'calc(30em + 60vw)' : 'calc(28em + 60vw)')};
  }
  @media (max-width: 400px) {
    height: ${(props) => (props.page === 'marketplace' ? 'calc(28em + 60vw)' : 'calc(29em + 60vw)')};
  }
`

const PreRenderImageRow = styled.div`
  position: absolute;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
`

const ViewPort = styled.div`
  position: relative;
  cursor: pointer;
  width: ${(props) => (props.page === 'marketplace' ? '45em' : '36em')};
  height: ${(props) => (props.page === 'marketplace' ? '30em' : '24em')};
  border-radius: 4px;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;

  @media (max-width: 1400px) {
    height: 24em;
    width: 36em;
  }
  overflow: hidden;
  @media (max-width: 700px) {
    width: 90vw;
    height: 60vw;
    display: flex;
    justify-content: center;
  }
`

const ImageRowContainer = styled.a`
  position: absolute;
  display: flex;
  height: 100%;
  width: 100%;
  @media (max-width: 700px) {
    height: 60vw;
    width: 90vw;
  }
`

const Image = styled.img`
  position: relative;
  height: ${(props) => (props.page === 'marketplace' ? '30em' : '24em')};
  width: ${(props) => props.index === 0 && props.page === 'marketplace' && '45em'};
  object-fit: cover;
  border-radius: 4px;
  @media (max-width: 1400px) {
    height: 24em;
  }

  @media (max-width: 700px) {
    height: 60vw;
    width: ${(props) => props.index === 0 && props.page === 'marketplace' && '90vw'};
  }
`

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 45em;
  height: 30em;
  border-radius: 4px;
  overflow: hidden;
  @media (max-width: 1400px) {
    height: 24em;
    width: 36em;
  }
  @media (max-width: 700px) {
    width: 90vw;
    height: 60vw;
  }
`

const LeftIndicator = styled(FaAngleLeft)`
  position: absolute;
  box-sizing: content-box;
  stroke-width: 20px;
  stroke: black;
  font-size: 6em;
  top: 50%;
  left: 5%;
  transform: translate(-50%, -50%);
  color: white;
  z-index: 1;
  :hover {
    opacity: 0.5;
  }
  @media (max-width: 700px) {
    left: 12%;
  }
`
const LeftTraversal = styled.div`
  position: absolute;
  width: 30%;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
`

const RightTraversal = styled.div`
  position: absolute;
  right: 0;
  width: 30%;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
`
const Middle = styled.a`
  position: absolute;
  right: 30%;
  width: 40%;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
`

const RightIndicator = styled(FaAngleRight)`
  position: absolute;
  box-sizing: content-box;
  stroke-width: 20px;
  stroke: black;
  color: white;
  font-size: 6em;
  top: 50%;
  left: 95%;
  transform: translate(-50%, -50%);
  z-index: 1;
  :hover {
    opacity: 0.5;
  }
  @media (max-width: 700px) {
    left: 88%;
  }
`
const TraverseIndicator = styled(FaRegWindowMinimize)`
  color: white;
  font-size: 4em;
  padding: 0;
  margin: 0 0.1em;
  opacity: ${(props) => (props.shown === 'true' ? '1' : '0.4')};
`

const FlexRow = styled.div`
  position: absolute;
  height: 50px;
  width: 100%;
  top: 85%;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  z-index: 1;
  @media (max-width: 700px) {
    width: 90%;
  }
`

const Column = styled.div`
  position: absolute;
  height: ${(props) => (props.page === 'marketplace' ? 'calc(30em / 1.1)' : 'calc(24em / 1.1)')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  font-size: 1.1em;
  padding: 5px 0 5px 2em;
  left: ${(props) => (props.page === 'marketplace' ? 'calc(45em / 1.1)' : 'calc(36em / 1.1)')};
  @media (max-width: 1400px) {
    left: calc(36em / 1.1);
    height: calc(24em / 1.1);
  }
  @media (max-width: 700px) {
    left: 6px;
    bottom: 6px;
    width: 100%;
    height: ${(props) => (props.page === 'marketplace' ? '20em' : '22em')};
    font-size: 1.2em;
    padding: 0;
  }
`

const Column1 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
`

const Row2 = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 0 5px 0;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`

const Row3 = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`

const SubWrapper = styled.div`
  display: flex;
  @media (max-width: 550px) {
    margin: 5px 0 0 0;
  }
`

const SubWrapper1 = styled.div`
  display: flex;
  flex-direction: column;
`
const ImgWrap = styled.a`
  position: relative;
  width: 10em;
  height: 10em;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    display: flex;
    align-items: center;
  }
`
const AvatarImg = styled.img`
  position: relative;
  width: 9em;
  height: 9em;
  border-radius: 999px;
  object-fit: cover;
  margin: 0.5em 1em 0.5em 0;
  @media (max-width: 550px) {
    width: 7em;
    height: 7em;
    margin: 0.5em 2em 0.5em 0;
  }
`
const H1 = styled.a`
  font-size: 18px;
  margin: 0 0 8px 0;
  padding: 0;
  font-weight: 500;
  line-height: 24px;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 700px) {
    margin: 0;
  }
`

const H2 = styled.a`
  font-size: 14px;
  padding: 0;
  font-weight: 400;
  line-height: 18px;
  word-break: break-word;
  margin: 0 0 12px 0;
  padding: 0;
  color: var(--dark-grey-2);
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`

const LocationTitle = styled.div`
  margin: 0 10px 0 0;
  color: var(--dark-grey-2);
  font-size: 14px;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    font-size: 12px;
  }
`

const Reviews = styled.div`
  margin: 0 0 0 5px;
  color: var(--dark-grey-2);
  font-size: 14px;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    font-size: 12px;
  }
`

const H5 = styled.a`
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`
const H6 = styled.a`
  font-size: 18px;
  margin: 3px 0 5px 0;
  padding: 0;
  font-weight: 400;
  line-height: 1.25;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    font-size: 16px;
  }
`
const StarIcon = styled(MdStar)`
  color: var(--forward);
  font-size: 18px;
  margin: 0;
  padding: 0;
`

const Link = styled.a`
  position: absolute;
  right: 0;
  bottom: 6px;
  padding: 0 0 2px 0;
  font-size: 14px;
  font-weight: 700;
  border-bottom: 1px solid var(--black);
  width: fit-content;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    font-size: 12px;
  }
`

const Link1 = styled.a`
  right: 0;
  bottom: 6px;
  padding: 0 0 2px 0;
  font-size: 14px;
  font-weight: 700;
  border-bottom: 1px solid var(--black);
  width: fit-content;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 550px) {
    font-size: 12px;
  }
`
